import { useState } from 'react';
import { enableStaffMode, checkPin, disableStaffMode, isValidPin } from '../services/staffMode';

/**
 * 👷 PIN-Dialog für den Mitarbeiter-Modus.
 * mode='setup': PIN festlegen (2×) → Modus an
 * mode='exit' : PIN eingeben → Modus aus; „PIN vergessen" → abmelden (setzt alles zurück)
 */
export default function StaffModeDialog({ mode, onClose, onForgot, t, colors }) {
  const [pin, setPin] = useState('');
  const [pin2, setPin2] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const dark = colors?.darkMode;

  const submit = async () => {
    setError('');
    if (!isValidPin(pin)) { setError(t('staff.pinFormat')); return; }
    setBusy(true);
    if (mode === 'setup') {
      if (pin !== pin2) { setError(t('staff.pinMismatch')); setBusy(false); return; }
      await enableStaffMode(pin);
      onClose(true);
    } else if (await checkPin(pin)) {
      disableStaffMode();
      onClose(true);
    } else {
      setError(t('staff.pinWrong'));
      setPin('');
    }
    setBusy(false);
  };

  const input = {
    width: '100%', padding: '14px', fontSize: 26, letterSpacing: '0.5em', textAlign: 'center',
    borderRadius: 10, border: `2px solid ${dark ? '#444' : '#ddd'}`, boxSizing: 'border-box', marginTop: 10,
    background: dark ? '#1b1f27' : '#fff', color: dark ? '#fff' : '#23272f',
  };
  const btn = (primary) => ({
    width: '100%', padding: '12px', borderRadius: 10, marginTop: 10, fontSize: 15, fontWeight: 600, cursor: 'pointer',
    border: primary ? 'none' : `1px solid ${dark ? '#444' : '#ddd'}`,
    background: primary ? '#1976d2' : 'transparent', color: primary ? '#fff' : (dark ? '#fff' : '#23272f'),
  });

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 7600,
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div data-testid="staff-dialog" style={{ background: dark ? '#23272f' : '#fff', color: dark ? '#fff' : '#23272f',
        borderRadius: 14, width: '100%', maxWidth: 380, padding: 18, boxShadow: '0 10px 40px rgba(0,0,0,0.4)' }}>
        <strong style={{ fontSize: 17 }}>👷 {mode === 'setup' ? t('staff.setupTitle') : t('staff.exitTitle')}</strong>
        <div style={{ fontSize: 13, color: dark ? '#aaa' : '#666', marginTop: 6, lineHeight: 1.5 }}>
          {mode === 'setup' ? t('staff.setupExplain') : t('staff.exitExplain')}
        </div>
        <input data-testid="staff-pin" type="password" inputMode="numeric" maxLength={4} autoFocus value={pin}
          onChange={(e) => setPin(e.target.value.replace(/\D/g, '').slice(0, 4))}
          onKeyDown={(e) => { if (e.key === 'Enter') submit(); }}
          placeholder="••••" style={input} />
        {mode === 'setup' && (
          <input data-testid="staff-pin2" type="password" inputMode="numeric" maxLength={4} value={pin2}
            onChange={(e) => setPin2(e.target.value.replace(/\D/g, '').slice(0, 4))}
            onKeyDown={(e) => { if (e.key === 'Enter') submit(); }}
            placeholder={t('staff.repeat')} style={{ ...input, letterSpacing: pin2 ? '0.5em' : 'normal', fontSize: pin2 ? 26 : 15 }} />
        )}
        {error && <div style={{ color: '#e5484d', fontSize: 13, marginTop: 8 }}>⚠️ {error}</div>}
        <button type="button" data-testid="staff-ok" disabled={busy} style={btn(true)} onClick={submit}>
          {mode === 'setup' ? t('staff.enable') : t('staff.unlock')}
        </button>
        <button type="button" style={btn(false)} onClick={() => onClose(false)}>{t('common.cancel')}</button>
        {mode === 'exit' && onForgot && (
          <button type="button" onClick={onForgot}
            style={{ marginTop: 12, background: 'none', border: 'none', color: dark ? '#9ab' : '#667',
              textDecoration: 'underline', fontSize: 12, cursor: 'pointer', width: '100%' }}>
            {t('staff.forgot')}
          </button>
        )}
      </div>
    </div>
  );
}
